export default __webpack_public_path__ + "static/media/myportfolio_navicon-light.1acaf1a9.svg";